<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">查询所需老人</div>
                <el-button type="danger" @click="closeSelf">关闭</el-button>
            </div>
            <div class="modal-body" style="padding:20px">
                <el-row>
                    <el-form :model="searchForm" inline :rules="rules" ref="searchForm">
                        <div>
                            <el-form-item prop="name">
                                <el-input  placeholder="请输入姓名" v-model="searchForm.name" maxlength="11" clearable style="width:200px;margin-right:10px"></el-input>
                            </el-form-item>
                            <el-form-item prop="phone">
                                    <el-input  placeholder="请输入手机号" v-model="searchForm.phone" maxlength="11" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                            <el-form-item prop="idCard">
                                <el-input  placeholder="请输入身份证号" v-model="searchForm.idCard" clearable style="width:200px;margin-right:20px"></el-input>
                            </el-form-item>
<!--                            <el-form-item prop="elderlyType">-->
<!--                                <el-select v-model="searchForm.elderlyType" placeholder="请选择老人分类" style="width:200px;margin-right:20px">-->
<!--                                    <el-option-->
<!--                                            v-for="item in elderlyTypeValue"-->
<!--                                            :key="item.value"-->
<!--                                            :label="item.label"-->
<!--                                            :value="item.value">-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item prop="elderlyClass">-->
<!--                                    <el-select v-model="searchForm.elderlyClass" placeholder="请选择老人类别" style="width:200px;margin-right:10px">-->
<!--                                        <el-option-->
<!--                                                v-for="item in elderlyClassValue"-->
<!--                                                :key="item.value"-->
<!--                                                :label="item.label"-->
<!--                                                :value="item.value">-->
<!--                                        </el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
<!--                            <el-form-item  prop="zoneCode" >-->
<!--                                <elSelectTree ref="elSelectTree" :options='zoneValue' accordion :props="zoneProps" v-on:getZoneValue="getZoneValue" style="width:200px;margin-right:10px"></elSelectTree>-->
<!--                            </el-form-item>-->
                            <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                        </div>
                    </el-form>
                </el-row>
                <el-row >
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <el-table-column fixed prop="name" label="姓名" width="100"></el-table-column>
                            <el-table-column prop="age" label="年龄" :formatter="getAge" ></el-table-column>
                            <el-table-column prop="idCard" label="身份证号" width="180"></el-table-column>
                            <el-table-column prop="userPhone" label="手机号" width="120"></el-table-column>
                            <el-table-column prop="areaName" label="所属地区" width="180"></el-table-column>
                            <el-table-column prop="cardNumber" label="卡号" width="120"></el-table-column>
                            <el-table-column prop="zoneName" label="所属区域" width="300"></el-table-column>
                            <el-table-column prop="elderlyClassName" label="老人分类"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="210">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleGetGood(scope.$index, scope.row)">添加服务</el-button>
                                    <el-button type="success" size="small" @click.native.prevent="handleOpenCart(scope.$index, scope.row)">查看购物车</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </el-row>

            </div>
        </div>
        <GetGood ref="myGetGood" v-show="showModalGetGood" v-on:closeGetGood="closeGetGood"></GetGood>
        <Cart ref="myCart" v-show="showModalCart" v-on:closeCart="closeCart"></Cart>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode, getStaffDTO} from "@/utils/auth";
    // import elSelectTree from "../../../components/ElSelectTree"
    import GetGood from "./GetGood"
    import Cart from "./Cart"
    import elderly from "@/common/status";


    export default {
        name: 'Add',
        props:['zoneValue'],
        data() {
            return {
                showModalGetGood:false,
                showModalCart:false,
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                th:this.$store.state.tableHeight,
                elderlyTypeValue:[{
                    value:-1,label:'服务类型'
                },
                {
                    value:0,label:'政府购买服务'
                },
                {
                    value:1,label:'有偿服务'
                }],
                elderlyClassValue:[{
                    value:-1,label:'补助类型'
                },
                {
                    value:0,label:'一般助餐补助老人'
                },
                {
                    value:1,label:'70岁以上低保老人'
                },
                {
                    value:2,label:'70岁以上空巢老人(无子女)'
                },
                {
                    value:3,label:'90岁以上高龄老人'
                }],
                loading: false,
                elderlyInfo:[],
                totalItems:0,
                searchForm:{
                    phone:'',
                    idCard:'',
                    zoneCode:'',
                    pageSize:20,
                    pageIndex:1,
                    name:''
                },
                rules:{
                    idCard:[elderly.rules.idCard[1],elderly.rules.idCard[2]]
                }
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th=val
            },
        },
        components:{
            GetGood,Cart
        },
        methods: {
            init(){
                this.name=''
                this.idCard=''
                this.zoneCode=''
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeAdd");
                this.$emit("getList");
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleGetGood(index, row) {
                this.$refs.myGetGood.init(row);
                this.showModalGetGood = !this.showModalGetGood;
            },
            handleOpenCart(index, row) {
                this.$refs.myCart.init(row);
                this.showModalCart = !this.showModalCart;
            },
            closeGetGood:function(){
                this.showModalGetGood = !this.showModalGetGood;
            },
            getZoneValue(val){
                this.searchForm.zoneCode=val
            },
            closeCart:function(){
                this.$emit("closeAdd");
                this.showModalCart = !this.showModalCart;
            },
            getAge(row) {
                var identityCard = row.idCard;

                var len = (identityCard + "").length;
                if (len == 0) {
                    return 0;
                } else {
                    if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
                    {
                        return 0;
                    }
                }
                var strBirthday = "";
                if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
                {
                    strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
                }
                if (len == 15) {
                    strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
                }
                //时间字符串里，必须是“/”
                var birthDate = new Date(strBirthday);
                var nowDateTime = new Date();
                var age = nowDateTime.getFullYear() - birthDate.getFullYear();
                //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
                if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;

            },
            getElderly(){

                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.searchForm.zoneCode=getStaffDTO().zoneCode
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetRechargeElderlyServe",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                            if(this.searchForm.zoneCode=='00000000-0000-0000-0000-000000000000'){
                                this.searchForm.zoneCode=''
                            }
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
